"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerForJobView = void 0;
const typeorm_1 = require("typeorm/browser");
const account_for_job_view_1 = require("./account-for-job-view");
const customer_invoice_contact_1 = require("./customer-invoice-contact");
const customer_receive_contact_1 = require("./customer-receive-contact");
let CustomerForJobView = class CustomerForJobView extends account_for_job_view_1.AccountForJobView {
    getBillingAddress() {
        var _a;
        return ((_a = this.billingAddress) === null || _a === void 0 ? void 0 : _a.postalCode) && this.billingAddress.street
            ? this.billingAddress
            : this.shippingAddress;
    }
    getBillingContact() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        return {
            id: null,
            apiId: null,
            accountId: null,
            salutation: (_b = (_a = this.billingContact) === null || _a === void 0 ? void 0 : _a.salutation) !== null && _b !== void 0 ? _b : this.salutation,
            firstName: (_d = (_c = this.billingContact) === null || _c === void 0 ? void 0 : _c.firstName) !== null && _d !== void 0 ? _d : this.firstName,
            lastName: (_f = (_e = this.billingContact) === null || _e === void 0 ? void 0 : _e.lastName) !== null && _f !== void 0 ? _f : this.lastName,
            email: (_h = (_g = this.billingContact) === null || _g === void 0 ? void 0 : _g.email) !== null && _h !== void 0 ? _h : this.email,
            phone: (_k = (_j = this.billingContact) === null || _j === void 0 ? void 0 : _j.phone) !== null && _k !== void 0 ? _k : this.phone,
            mobilePhone: (_m = (_l = this.billingContact) === null || _l === void 0 ? void 0 : _l.mobilePhone) !== null && _m !== void 0 ? _m : this.mobilePhone,
            language: (_o = this.language) !== null && _o !== void 0 ? _o : this.getBillingAddress().countryCode,
            useAs: null,
        };
    }
};
__decorate([
    (0, typeorm_1.Column)('text', {
        nullable: true,
        name: 'eid__c',
    }),
    __metadata("design:type", String)
], CustomerForJobView.prototype, "eid", void 0);
__decorate([
    (0, typeorm_1.OneToOne)((type) => customer_invoice_contact_1.CustomerInvoiceContact, {
        eager: true,
    }),
    (0, typeorm_1.JoinColumn)({
        name: 'id',
        referencedColumnName: 'accountId',
    }),
    __metadata("design:type", customer_invoice_contact_1.CustomerInvoiceContact)
], CustomerForJobView.prototype, "billingContact", void 0);
__decorate([
    (0, typeorm_1.OneToOne)((type) => customer_receive_contact_1.CustomerReceiveContact, {
        eager: true,
    }),
    (0, typeorm_1.JoinColumn)({
        name: 'id',
        referencedColumnName: 'accountId',
    }),
    __metadata("design:type", customer_receive_contact_1.CustomerReceiveContact)
], CustomerForJobView.prototype, "receiveContact", void 0);
CustomerForJobView = __decorate([
    (0, typeorm_1.Entity)('account', { schema: 'public', synchronize: false })
], CustomerForJobView);
exports.CustomerForJobView = CustomerForJobView;
//# sourceMappingURL=customer-for-job-view.js.map